import { Editor, Element, type NodeEntry, Transforms } from "slate";
import { type LinkElement, type SlateEditor } from "../types";
import { type LinkModalFormData } from "./Modal";

const unwrapLink = (editor: SlateEditor) => {
  Transforms.unwrapNodes(editor, {
    match: (n) => !Editor.isEditor(n) && Element.isElement(n) && n.type === "a"
  });
};

export const upsertLink = (editor: SlateEditor, data: LinkModalFormData) => {
  const linkNode = getActiveLink(editor);
  if (!data.url && linkNode) {
    unwrapLink(editor);
    return;
  }

  if (data.url) {
    if (linkNode) {
      editor.delete({
        at: linkNode[1]
      });
    }

    const link: LinkElement = {
      type: "a",
      href: data.url,
      target: data.isNewWindow ? "_blank" : undefined,
      children: [{ text: data.text }]
    };

    // https://app.clickup.com/t/86c3aqt16. An empty paragraph is needed to separate the link from the next paragraph.
    Transforms.insertNodes(editor, [link, { type: "p", children: [{ text: "" }] }]);
    Transforms.collapse(editor, { edge: "end" });
  }
};

export const getActiveLink = (editor: Editor): NodeEntry<LinkElement> | null => {
  const [link] = Editor.nodes(editor, {
    match: (n) => !Editor.isEditor(n) && Element.isElement(n) && n.type === "a"
  });
  return link as NodeEntry<LinkElement>;
};
